import AudiencePage from './AudiencePage';

const GITA_BAND = (
  <div className="rounded-[28px] p-6 md:p-12 border border-black/5" style={{ background: 'linear-gradient(135deg, #fff8ec 0%, #fef2d9 100%)' }} data-testid="gita-wisdom-band" data-reveal>
    <div className="text-center max-w-[680px] mx-auto mb-10 md:mb-12">
      <p className="text-[#b25e00] text-[13px] font-semibold tracking-tight mb-3">Wisdom from the Bhagavad Gita</p>
      <h3 className="text-[#1d1d1f]" style={{ fontSize: 'clamp(28px, 3.4vw, 40px)', lineHeight: 1.05, letterSpacing: '-0.025em', fontWeight: 600 }}>
        Ancient verses.<br />Modern emotional practice.
      </h3>
      <p className="text-[#515154] text-[15px] mt-4" style={{ lineHeight: 1.5, letterSpacing: '-0.005em' }}>
        Three teachings from Krishna to Arjuna &mdash; still the clearest map for equanimity, self-reliance, and inner peace in later life.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5" data-testid="gita-verses">
      {/* Verse 1 — BG 2.14 */}
      <div className="rounded-[20px] p-7 bg-white/85 backdrop-blur border border-black/5" data-testid="gita-verse-1">
        <p className="text-[#b25e00] text-[11px] font-semibold tracking-widest mb-4">BHAGAVAD GITA · 2.14</p>
        <p className="text-[#1d1d1f] mb-3" style={{ fontFamily: '"Noto Serif Devanagari", "Kokila", serif', fontSize: '19px', lineHeight: 1.6 }}>
          मात्रास्पर्शास्तु कौन्तेय<br />
          शीतोष्णसुखदुःखदाः।<br />
          आगमापायिनोऽनित्याः<br />
          तांस्तितिक्षस्व भारत॥
        </p>
        <p className="text-[#6e6e73] text-[13px] italic mt-4" style={{ lineHeight: 1.5, letterSpacing: '-0.005em' }}>
          Mātrā-sparśās tu Kaunteya, śītoṣṇa-sukha-duḥkha-dāḥ; āgamāpāyino &lsquo;nityās tāṁs titikṣasva Bhārata.
        </p>
        <p className="text-[#1d1d1f] text-[14px] mt-5" style={{ lineHeight: 1.55, letterSpacing: '-0.005em' }}>
          <span className="font-semibold">Meaning.</span> The contact of the senses gives rise to cold and heat, pleasure and pain. They come and they go &mdash; they are impermanent. Endure them with calm.
        </p>
        <p className="text-[#b25e00] text-[13px] mt-3" style={{ lineHeight: 1.5, letterSpacing: '-0.005em' }}>
          <span className="font-semibold">For you.</span> Emotions are weather, not climate. Meet them, let them pass. Equanimity is a practice, not a personality.
        </p>
      </div>

      {/* Verse 2 — BG 6.5 */}
      <div className="rounded-[20px] p-7 bg-white/85 backdrop-blur border border-black/5" data-testid="gita-verse-2">
        <p className="text-[#b25e00] text-[11px] font-semibold tracking-widest mb-4">BHAGAVAD GITA · 6.5</p>
        <p className="text-[#1d1d1f] mb-3" style={{ fontFamily: '"Noto Serif Devanagari", "Kokila", serif', fontSize: '19px', lineHeight: 1.6 }}>
          उद्धरेदात्मनात्मानं<br />
          नात्मानमवसादयेत्।<br />
          आत्मैव ह्यात्मनो बन्धुः<br />
          आत्मैव रिपुरात्मनः॥
        </p>
        <p className="text-[#6e6e73] text-[13px] italic mt-4" style={{ lineHeight: 1.5, letterSpacing: '-0.005em' }}>
          Uddhared ātmanātmānaṁ, nātmānam avasādayet; ātmaiva hyātmano bandhur, ātmaiva ripur ātmanaḥ.
        </p>
        <p className="text-[#1d1d1f] text-[14px] mt-5" style={{ lineHeight: 1.55, letterSpacing: '-0.005em' }}>
          <span className="font-semibold">Meaning.</span> Lift yourself by your own Self &mdash; do not let the Self sink. The Self alone is the friend of the Self, and the Self alone is its enemy.
        </p>
        <p className="text-[#b25e00] text-[13px] mt-3" style={{ lineHeight: 1.5, letterSpacing: '-0.005em' }}>
          <span className="font-semibold">For you.</span> No one else can raise your inner state for you. Choose thoughts and habits that are a friend to who you are becoming.
        </p>
      </div>

      {/* Verse 3 — BG 2.70 */}
      <div className="rounded-[20px] p-7 bg-white/85 backdrop-blur border border-black/5" data-testid="gita-verse-3">
        <p className="text-[#b25e00] text-[11px] font-semibold tracking-widest mb-4">BHAGAVAD GITA · 2.70</p>
        <p className="text-[#1d1d1f] mb-3" style={{ fontFamily: '"Noto Serif Devanagari", "Kokila", serif', fontSize: '19px', lineHeight: 1.6 }}>
          आपूर्यमाणमचलप्रतिष्ठं<br />
          समुद्रमापः प्रविशन्ति यद्वत्।<br />
          तद्वत्कामा यं प्रविशन्ति सर्वे<br />
          स शान्तिमाप्नोति न कामकामी॥
        </p>
        <p className="text-[#6e6e73] text-[13px] italic mt-4" style={{ lineHeight: 1.5, letterSpacing: '-0.005em' }}>
          Āpūryamāṇam-acala-pratiṣṭhaṁ samudram āpaḥ praviśanti yadvat; tadvat kāmā yaṁ praviśanti sarve sa śāntim āpnoti na kāma-kāmī.
        </p>
        <p className="text-[#1d1d1f] text-[14px] mt-5" style={{ lineHeight: 1.55, letterSpacing: '-0.005em' }}>
          <span className="font-semibold">Meaning.</span> As rivers flow into the ocean, which is full yet unmoved, so desires enter one who is settled. Such a person finds peace &mdash; not the one who chases desires.
        </p>
        <p className="text-[#b25e00] text-[13px] mt-3" style={{ lineHeight: 1.5, letterSpacing: '-0.005em' }}>
          <span className="font-semibold">For you.</span> Peace is not the absence of feeling. It is being full enough that new emotions can enter without disturbing your depth.
        </p>
      </div>
    </div>
  </div>
);

const CHAPTERS = [
  {
    num: '01',
    icon: 'self_improvement',
    title: 'Body',
    desc: 'Decades of carrying families, careers, and loss live in the body. We begin gently — sleep, breath, and simple practices that respect your pace and rebuild energy for the years ahead.'
  },
  {
    num: '02',
    icon: 'visibility',
    title: 'Truth',
    desc: 'A lifetime of being strong for others can hide what you actually feel. This chapter makes room for honesty — grief, joy, regret, pride — seen clearly and held without judgment.'
  },
  {
    num: '03',
    icon: 'spa',
    title: 'Soul',
    desc: 'Meaning deepens with years. Simple mind practices and quiet reflection connect you to gratitude, faith, and the positive energy that makes this season rich.'
  },
  {
    num: '04',
    icon: 'hearing',
    title: 'Senses',
    desc: 'You perceive the world through a lifetime of experience. Understand how that lens shapes each day — and how to keep it curious, not closed.'
  }
];

const ForSeniors = () => (
  <AudiencePage
    slug="seniors"
    eyebrow="For Senior Citizens"
    title={<>The chapter your life<br />was writing toward.</>}
    intro="Retirement isn't the finish line. It's the season with the most emotional wisdom — and the most to give. mindpulsei helps you rebuild purpose, deepen the bonds that matter, and turn a lifetime of experience into legacy."
    image="https://images.unsplash.com/photo-1514415008039-efa173293080?w=1200&q=80&auto=format&fit=crop"
    imageAlt="Warm senior couple sharing a moment by the water"
    chapters={CHAPTERS}
    wisdomBand={GITA_BAND}
    quote="The wisest years deserve the deepest peace."
    quoteSub="Talk to us about where you are and what this chapter could hold — we'll shape the practice around you."
  />
);

export default ForSeniors;
